/**
 * Constants for help links inside EnHelpMenu and Login page.
 */
export const HelpLinks = {
    FAQ: 'https://enloc-externally-shared.atlassian.net/wiki/spaces/07softes/pages/28278785/H+ufig+gestellte+Fragen+zur+Plattform+EN.Gine+FAQ',
    Documentation: 'https://enloc-externally-shared.atlassian.net/wiki/spaces/07softes/pages/163952/07.1-+SOFT+-EN.Gine',
    Imprint: 'https://www.enloc.de/impressum-enloc-port-gmbh',
    PrivacyPolicy: 'https://www.enloc.de/datenschutz-enloc-port-gmbh',
    SupportEmail: 'hilfe@enloc.de',
};
